{
    "Profile_Renewal.yourInsurance": "Your {productName} Insurance",
    "Profile_Renewal.reviewRenewal": "⭮ Review Renewal",
    "Profile_Renewal.documentAcceptance": "I have reviewed and accepted the proposed quote.",
    "Profile_Renewal.downloadQuote": "Download Quote",
    "Profile_Renewal.signDocuments": "Sign Documents",
    "Profile_Renewal.chooseYourRenewal": "Choose Your Renewal",
    "Profile_Renewal.reviewPoliciesInfo": "Review the status of your current insurance policies and applications, add policies, or make changes.",
    "Profile_Renewal.start": "Start",
    "Profile_Renewal.finish": "Finish",
    "Profile_Renewal.insuranceFor": "{clientName}'s Insurance",
    "Profile_Renewal.reviewCustomerInfo": "Review the status and make changes to this customer's policy information.",
    "Profile_Renewal.shopRenewalTitle": "Shop your Renewal right here, in one place",
    "Profile_Renewal.shopRenewalDescription": "Toggle between the best rates and pick the one that works for you best. Once you accept the quote, a broker will process it for you, don't worry if you need more changes, your broker can guide you through them. Once completed you will be notified that your documents are ready to sign.",
    "Profile_Renewal.riskChangeSummary": "Risk Change Summary",
    "Profile_Renewal.homeOwner": "Home Owner",
    "Profile_Renewal.landlordOwner": "Landlord Owner",
    "Profile_Renewal.rvOwner": "RV Owner",
    "Profile_Renewal.renewalReview": "Renewal Review",
    "Profile_Renewal.acceptQuote": "Accept Quote",
    "Profile_Renewal.signDocs": "Sign Docs",
    "Profile_Renewal.attention": "Attention",
    "Profile_Renewal.errorMessage": "Error Message",
    "Profile_Renewal.warning": "Warning",
    "Profile_Renewal.notifications.review": "Hi {clientName}, your Home insurance is up for renewal, it's time to review!",
    "Profile_Renewal.notifications.reviewAccept": "Please review and accept your preferred quote.",
    "Profile_Renewal.notifications.readyToSign": "Your Renewal Docs are ready to sign. Please review and sign documents.",
    "Profile_Renewal.notifications.workingOnPolicy": "Your Renewal Docs are signed. Your broker is working on your policy.",
    "Profile_Renewal.notifications.issuedByBroker": "Your Renewal Docs are signed and issued by your broker.",
    "Profile_Renewal.notifications.broker.pendingReview": "{clientName}'s renewal is pending review.",
    "Profile_Renewal.notifications.broker.needsIssued": "{clientName}'s renewal quotes need to be issued.",
    "Profile_Renewal.notifications.broker.waitingAccept": "Waiting for {clientName} to accept a quote.",
    "Profile_Renewal.notifications.broker.quoteAccepted": "{clientName} has accepted the quote.",
    "Profile_Renewal.notifications.broker.waitingBind": "{clientName} has signed documents and waiting for you to bind the policy.",
    "Profile_Renewal.notifications.broker.finalizePolicy": "Please finalize the policy and issue all documents."
}
